 <div class="veloSpinner" [ngClass]="{'off': !spinner}">
 	<div class="spinner">
 		<div class="loader"></div>
 	</div>
 </div>
 <div class="guardadoAutomatico" [ngClass]="{'off': !autoSave}">
 	<span class="parpadea" translate>save</span>
 </div>

<router-outlet></router-outlet>


// WEBPACK FOOTER //
// ./src/app/app.component.html